import styles from "./Contact.module.css"
import Header from "../../components/Header"
import Footer from "../../components/Footer"
import Container from "../../components/Container"

function Contact() {
    return(
        <>
        <Header />
        <div className={styles.container}>
            <div className={styles.title}>
                <h1>We'd love to hear <br/> from <span> you</span>.</h1>
                <p>Whether you have a question, need support, <br/> or want to explore business opportunities, our <br/> team is ready to assist you.</p>
            </div>

             <section className={styles.contactMax}>
                <div className={styles.infos}>
                    <div className={styles.imgSignal}></div>
                    <p><span>Address:</span></p>
                    <p> Corinto - MG <br/> 39.200-000 <br/> Brazil</p>
                </div>

                <div className={styles.infos}>
                    <div className={styles.imgPhone}></div>
                    <p><span>Phone:</span></p>
                    <nav>
                        <div className={styles.whatsapp}></div>
                        <div className={styles.signal}></div>
                        <div className={styles.telegram}></div>
                    </nav>
                    <p>+55 31 31575258</p>
                </div>

                <div className={styles.infos}>
                    <div className={styles.imgEmail}></div>
                    <p><span>Email:</span></p>
                    <p>info@engiforge.dev</p>
                </div>
            </section>

            <section className={styles.contactMin}>
                    <div className={styles.imgSignal}></div>
                    <p><span>Address:</span></p>
                    <p>Corinto - MG <br/> 39.200-000 <br/> Brazil</p>

                    <div className={styles.imgPhone}></div>
                    <div className={styles.symbolMin}>
                        <p><span>Phone:</span></p>
                        <div>
                            <div className={styles.whatsapp}></div>
                            <div className={styles.signal}></div>
                            <div className={styles.telegram}></div>
                        </div>
                    </div>
                    <p>+55 38 31575258</p>

                    <div className={styles.imgEmail}></div>
                    <p><span>Email:</span></p>
                    <p>info@engiforge.dev</p>
            </section>

            <h2>Get in touch with <span>us</span>.</h2>
            
            <form className={styles.form} method="post" action="/api/list.php">
                <input type="hidden" name="csrf_token" value="<?php echo $_SESSION['csrf_token'] ?>"></input>
                <input type="text" placeholder="Full Name" id="name" maxlength="55" required></input>
                <input type="email" placeholder="E-mail" id="email" maxlength="50" required></input>
                <input type="text" placeholder="Subject" id="subject" maxlength="80" required></input>
                <textarea placeholder="Type your message here..." id="message" maxlength="1000" required></textarea>
                <button type="submit" value="submit"> SEND MESSAGE </button>
            </form> 
        </div>
        <Footer />
        </>
    )
}

export default Contact
